import CLPViewState, {
    LabelApplyMethod,
} from 'owa-mail-protection-types/lib/schema/clp/CLPViewState';
import internalSetSelectedCLPLabel from '../../actions/clp/internalSetSelectedCLPLabel';

export default function applyAutoLabel(clpViewState: CLPViewState) {
    const { autoLabelViewState } = clpViewState;
    const { automatic } = autoLabelViewState;
    internalSetSelectedCLPLabel(clpViewState, automatic, LabelApplyMethod.Automatic);
}
